import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, DeferLoadingStrategy, I18nModule } from '@spartacus/core';
import { MyaccountPaymentDetailsComponent } from './myaccount-payment-details.component';

@NgModule({
  declarations: [MyaccountPaymentDetailsComponent],
  imports: [
    CommonModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        MyAccountAccountInfoPaymentDetailsFlexComponent: {
          component: MyaccountPaymentDetailsComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
  ],
})
export class MyaccountPaymentDetailsModule {}
